var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExtract = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.29 -255.348)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-extract-2",
    d: "M-301.29,255.348a10,10,0,0,0-10,10,10,10,0,0,0,10,10,10,10,0,0,0,10-10A10,10,0,0,0-301.29,255.348Zm0,18.83a8.84,8.84,0,0,1-8.83-8.83,8.84,8.84,0,0,1,8.83-8.83,8.84,8.84,0,0,1,8.83,8.83A8.84,8.84,0,0,1-301.29,274.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-extract-2",
    d: "M-301.29,257.518a7.839,7.839,0,0,0-7.83,7.83,7.839,7.839,0,0,0,7.83,7.83,7.839,7.839,0,0,0,7.83-7.83A7.839,7.839,0,0,0-301.29,257.518Zm.6,11.937v.673a.6.6,0,0,1-.6.6.6.6,0,0,1-.6-.6v-.674a2.387,2.387,0,0,1-1.609-1.394.6.6,0,0,1,.322-.781.6.6,0,0,1,.781.321,1.194,1.194,0,0,0,1.1.736,1.2,1.2,0,0,0,1.2-1.2,1.2,1.2,0,0,0-1.2-1.2,2.393,2.393,0,0,1-2.39-2.39,2.4,2.4,0,0,1,1.792-2.315v-.673a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6v.674a2.387,2.387,0,0,1,1.609,1.394.6.6,0,0,1-.322.781.6.6,0,0,1-.781-.321,1.193,1.193,0,0,0-1.1-.735,1.2,1.2,0,0,0-1.195,1.2,1.2,1.2,0,0,0,1.195,1.2,2.393,2.393,0,0,1,2.39,2.39A2.4,2.4,0,0,1-300.692,269.455Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExtract, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/extract.59eb3d3e.svg";
export { ForwardRef as ReactComponent };